/**
 * Site-level configuration for the Jianeng marketing website.
 * Product URLs can be overridden at build time via Vite env vars.
 */
export const siteConfig = {
  /** 品牌简称（浏览器标题、版权等） */
  name: "加能财智",
  /** 顶栏 / 页脚 Logo 旁展示名 */
  logoName: "加能财税智能化平台",
  tagline: "会计师与税务师事务所 AI 服务平台",
  description:
    "加能财智面向会计师与税务师事务所，连接招标线索、标书制作、审计作业与专业 AI 服务。",
  locale: "zh-CN",
  themeColor: "#0B1428",
  copyrightYear: 2026,
  defaultTitle: "加能财智｜会计师与税务师事务所 AI 服务平台",
  /** 运营主体全称（页脚备案与版权区） */
  companyName: "杭州加能信息科技有限公司",
  /** ICP 备案号（展示文案，不含前缀说明） */
  icpFiling: "浙ICP备2026062892号-1",
  /** 工信部备案查询入口 */
  icpFilingUrl: "https://beian.miit.gov.cn/",
} as const;

export const pageMeta = {
  home: {
    title: siteConfig.defaultTitle,
    description: siteConfig.description,
  },
  products: {
    title: "产品与解决方案｜加能财智",
    description:
      "智能标讯与标书智作已上线；审计智作与小加+持续规划。按任务选择适合事务所的 AI 产品。",
  },
  security: {
    title: "安全与合规｜加能财智",
    description:
      "产品可独立部署，数据范围与访问边界清晰说明；AI 辅助提效，关键结论由专业人员判断与复核。",
  },
  notFound: {
    title: "页面未找到｜加能财智",
    description: "您访问的页面不存在。",
  },
} as const;

function readEnvUrl(key: string): string | null {
  const value = import.meta.env[key];
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** Build-time product destination URLs (optional until products go live). */
export const productUrls = {
  bid: readEnvUrl("VITE_PRODUCT_BID_URL"),
  proposal: readEnvUrl("VITE_PRODUCT_PROPOSAL_URL"),
  audit: readEnvUrl("VITE_PRODUCT_AUDIT_URL"),
  jia: readEnvUrl("VITE_PRODUCT_JIA_URL"),
} as const;
